require('./brokerConvenienceMiFIDTestStep4.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @commons
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { EmptyState } = require('commonsComponents/emptyState');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
const { shouldCoherenceControl } = require('mifid/utilities/mifidValidHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

// @actions
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_TYPE,
    BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_PARAMS
} = require('constants/index');

const CLASS_NAME = 'broker-convenience-mifid-test-step-4';

class BrokerConvenienceMiFIDTestStep4 extends React.Component  {
    componentWillMount(){
        const { getCurrentTestScore, immBrokerConvenienceMiFIDTest } = this.props;
        if (
            !immBrokerConvenienceMiFIDTest.get('loadingCurrentTest') &&
            !immBrokerConvenienceMiFIDTest.get('fetchedCurrentTest') &&
            immBrokerConvenienceMiFIDTest.get('hasRoboPortfolio') &&
            shouldCoherenceControl()
        ){
            getCurrentTestScore();
        }
    }

    buildSignaturePattern() {
        const { immBrokerConvenienceMiFIDTest } = this.props
        const signaturePatternComponent = (
            <SignaturePattern
                operationType={BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_TYPE}
                operationParams={BROKER_CONVENIENCE_MIFID_TEST_SIGNATURE_OPERATION_PARAMS}
            />
        );

        if(!shouldCoherenceControl() ){
            return (signaturePatternComponent);
        }
        const continueWithDisapproved = immBrokerConvenienceMiFIDTest.get('continueWithDisapproved');
        const fetchedCurrentTest = immBrokerConvenienceMiFIDTest.get('fetchedCurrentTest');
        const disaprovedCurrentTest = immBrokerConvenienceMiFIDTest.get('disaprovedCurrentTest');
        const hasRoboPortfolio = immBrokerConvenienceMiFIDTest.get('hasRoboPortfolio');

        if (__CONTACT_CENTER__) {
            if (
                (continueWithDisapproved && fetchedCurrentTest && disaprovedCurrentTest) ||
                (fetchedCurrentTest && !disaprovedCurrentTest) ||
                !hasRoboPortfolio
            ){
                return (signaturePatternComponent);
            }
        }else {
            if ((fetchedCurrentTest && !disaprovedCurrentTest) || !hasRoboPortfolio) {
                return (signaturePatternComponent);
            }
        }
        return null;
    }

    buildConfirmationScriptCC() {
        const { immBrokerConvenienceMiFIDTest, immProfileFields } = this.props
        const continueWithDisapproved = immBrokerConvenienceMiFIDTest.get('continueWithDisapproved');
        const fetchedCurrentTest = immBrokerConvenienceMiFIDTest.get('fetchedCurrentTest');
        const disaprovedCurrentTest = immBrokerConvenienceMiFIDTest.get('disaprovedCurrentTest');
        const clientName = <span>{PersonalDataHelper.getFullName(immProfileFields, false)}</span>;
        if(continueWithDisapproved && fetchedCurrentTest && disaprovedCurrentTest){
            return(
                <div className={`${CLASS_NAME}__cc-disclaimer-confirmation`}>
                    <h2 className={`${CLASS_NAME}__cc-disclaimer-confirmation-title`}>
                        <FormattedText value="broker-convenienceMifidDisapprovedCCStep4DisclaimerTitle" />
                    </h2>
                    <BlockInfo>
                        <p className={`${CLASS_NAME}__cc-disclaimer-confirmation-content`}>
                            <FormattedText value="broker-convenienceMifidDisapprovedCCStep4DisclaimerContent1" />
                        </p>
                        <p className={`${CLASS_NAME}__cc-disclaimer-confirmation-content`}>
                            <FormattedTextWithComponents
                                value="broker-convenienceMifidDisapprovedCCStep4DisclaimerContent2"
                                injectedComponents={[
                                    clientName
                                ]}
                            />
                        </p>
                    </BlockInfo>
                </div>
            );
        }
        return(
            <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
        );
    }

    render(){
        const { immBrokerConvenienceMiFIDTest, actions, cancelButton, nextButton, getCurrentTestScore} = this.props;
        if (immBrokerConvenienceMiFIDTest.get('loadingCurrentTest')){
            return (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            );
        }
        if (immBrokerConvenienceMiFIDTest.get('errorCurrentTest')){
            const lostConnectionFirstLine = formatText('broker-lostConnectionFirstLine');
            const retryButton = (
                <OKButton onClick={() => getCurrentTestScore()}>
                    <FormattedText value="broker-retry" />
                </OKButton>
            );
            return (
                <ContentBox customClassName="broker-general-view__robo-error">
                    <EmptyState button={retryButton} primaryText={lostConnectionFirstLine} iconType="nointernet-wealth"/>
                </ContentBox>
            );
        }
        const isLoading = immBrokerConvenienceMiFIDTest.get('loading');
        const operative = formatText('operatives-convenienceMiFIDTest');
        const confirmationTitleClassName = contactCenterClassName('print-title', `${CLASS_NAME}__title`);
        const signaturePattern = this.buildSignaturePattern();
        const confirmationScriptCC = this.buildConfirmationScriptCC();
        return (
            <WizardStep
                actions={actions}
                cancelButton={cancelButton}
                nextButton={nextButton}
                immFinalButton="broker-convenienceMifidTestSend"
                position="last"
                isLoading={isLoading}
            >
                <h4 className={confirmationTitleClassName}>
                    <FormattedText value="broker-convenienceMifidTestSecurityConfirmation"/>
                </h4>
                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                </ContactCenterRender>
                <p className={`${CLASS_NAME}__info no-print-out`}>
                    <FormattedText value="broker-convenienceMifidTestCheckAnswersBeforeContinue"/>
                </p>
                <div className={`${CLASS_NAME}__field`}>
                <ContactCenterRender>
                    {confirmationScriptCC}
                </ContactCenterRender>
                    {signaturePattern}
                </div>
            </WizardStep>
        );
    }
};

BrokerConvenienceMiFIDTestStep4.propTypes = {
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerConvenienceMiFIDTestStep4.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports.constructor = BrokerConvenienceMiFIDTestStep4;
module.exports.BrokerConvenienceMiFIDTestStep4 = connect(
    (state) => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immProfileFields: state.profile,
    }),
    {getCurrentTestScore: BrokerConvenienceMiFIDTestAction.getCurrentTestScore,}
)(BrokerConvenienceMiFIDTestStep4);